import Layout from '@/layout';

/**
 * 店铺装修（qdiy）路由 —— 商户端
 *
 * 与平台端是同一套装修体系（后端 service 共用，数据按 mer_id 隔离），
 * 商户端只保留店铺自己用得上的几页：页面装修、我的模板、模板市场、素材管理。
 * 底部导航、全局配置、海报由平台统一维护，这里不放。
 */
var qdiyRouter = {
  path: '/qdiy',
  component: Layout,
  redirect: '/qdiy/page',
  name: 'QDiy',
  meta: {
    // 与老 pagediy 的「店铺装修」区分，两套并存期间靠后缀分辨
    title: '店铺装修（新版）',
    icon: 'clipboard'
  },
  children: [{
    path: 'page',
    name: 'qdiyPage',
    component: function component() {
      return import('@/views/qdiy/page/index');
    },
    meta: {
      title: '店铺页面',
      noCache: true
    }
  }, {
    path: 'editor/:id',
    name: 'qdiyEditor',
    hidden: true,
    component: function component() {
      return import('@/views/qdiy/editor/index');
    },
    meta: {
      title: '页面编辑',
      noCache: true,
      activeMenu: '/qdiy/page'
    }
  }, {
    path: 'mytemplate',
    name: 'qdiyMyTemplate',
    component: function component() {
      return import('@/views/qdiy/mytemplate/index');
    },
    meta: {
      title: '我的模板',
      noCache: true
    }
  }, {
    path: 'market',
    name: 'qdiyMarket',
    component: function component() {
      return import('@/views/qdiy/market/index');
    },
    meta: {
      title: '模板市场',
      noCache: true
    }
  }, {
    path: 'material',
    name: 'qdiyMaterial',
    component: function component() {
      return import('@/views/qdiy/material/index');
    },
    meta: {
      title: '素材管理',
      noCache: true
    }
  }]
};
export default qdiyRouter;